var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { class: _vm.embedded ? "" : "ma-5", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { class: _vm.embedded ? "pa-0" : "" },
        [
          !_vm.embedded
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-4",
                  attrs: {
                    type: "info",
                    outlined: "",
                    dense: "",
                    icon: "mdi-domain",
                  },
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("current-organization")) + ":"),
                  ]),
                  _c("span", { staticClass: "font-weight-medium ml-1" }, [
                    _vm._v(
                      _vm._s(_vm.organizationName) +
                        " (" +
                        _vm._s(_vm.organizationId) +
                        ")"
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.embedded
            ? _c(
                "div",
                { ref: "embeddedList", staticClass: "embedded-actions-list" },
                _vm._l(_vm.availableActions, function (action) {
                  return _c(
                    "div",
                    {
                      key: action.key,
                      staticClass: "action-menu-item",
                      class: {
                        "action-disabled":
                          action.key === "avancieTenants" &&
                          !_vm.hasAvancieIntegration,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-start" },
                        [
                          _c(
                            "v-avatar",
                            {
                              staticClass: "mr-3 flex-shrink-0",
                              attrs: { color: action.color, size: "36" },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "white", size: "18" } },
                                [_vm._v(_vm._s(action.icon))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex-grow-1 min-width-0" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-subtitle-2 font-weight-bold",
                                },
                                [_vm._v(" " + _vm._s(action.title) + " ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-caption grey--text action-description",
                                },
                                [_vm._v(" " + _vm._s(action.description) + " ")]
                              ),
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-2 flex-shrink-0",
                              attrs: {
                                small: "",
                                color: action.color,
                                outlined: "",
                                loading: _vm.loading[action.loadingKey],
                                disabled:
                                  _vm.anyLoading ||
                                  (action.key === "avancieTenants" &&
                                    !_vm.hasAvancieIntegration),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.executeAction(action)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("execute")) + " ")]
                          ),
                        ],
                        1
                      ),
                      action.key === "avancieTenants" &&
                      _vm.avancieTenantsResults &&
                      _vm.avancieTenantsResults.length > 0
                        ? _c(
                            "div",
                            { staticClass: "mt-2 ml-12 avancie-tenants-list" },
                            [
                              _c(
                                "v-list",
                                { staticClass: "pa-0", attrs: { dense: "" } },
                                _vm._l(
                                  _vm.avancieTenantsResults,
                                  function (tenant, index) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: tenant.id || index,
                                        staticClass: "px-0",
                                      },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          { staticClass: "py-1" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "text-body-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      tenant.name || tenant.code
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [_vm._v(_vm._s(tenant.id))]
                                                ),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "ml-1 copy-icon",
                                                    attrs: { "x-small": "" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.copyToClipboard(
                                                          tenant.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" mdi-content-copy ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : action.key === "avancieTenants" &&
                          _vm.avancieTenants &&
                          _vm.avancieTenantsResults.length === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "mt-2 ml-12 text-caption grey--text",
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("no-avancie-tenants")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              )
            : _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "offset-y": "",
                    "max-height": "500",
                    "min-width": "600",
                    "max-width": "700",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-card",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass:
                                    "action-menu-btn d-flex align-center pa-4",
                                  class: {
                                    "action-menu-btn--active":
                                      _vm.actionsMenuOpen,
                                  },
                                  attrs: { outlined: "" },
                                },
                                "v-card",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "mr-4",
                                  attrs: { color: "primary", size: "40" },
                                },
                                [
                                  _c("v-icon", { attrs: { color: "white" } }, [
                                    _vm._v("mdi-cog-play"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "flex-grow-1" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-subtitle-1 font-weight-medium primary--text",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("select-action")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "text-caption grey--text" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("select-action-hint")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "v-icon",
                                { attrs: { color: "primary", size: "24" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.actionsMenuOpen
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.actionsMenuOpen,
                    callback: function ($$v) {
                      _vm.actionsMenuOpen = $$v
                    },
                    expression: "actionsMenuOpen",
                  },
                },
                [
                  _c(
                    "v-card",
                    { ref: "menuCard", staticClass: "actions-menu-card" },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "pa-2" },
                        _vm._l(_vm.availableActions, function (action) {
                          return _c(
                            "div",
                            {
                              key: action.key,
                              staticClass: "action-menu-item",
                              class: {
                                "action-disabled":
                                  action.key === "avancieTenants" &&
                                  !_vm.hasAvancieIntegration,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-start" },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      staticClass: "mr-3 flex-shrink-0",
                                      attrs: {
                                        color: action.color,
                                        size: "36",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "white", size: "18" },
                                        },
                                        [_vm._v(_vm._s(action.icon))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex-grow-1 min-width-0" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(action.title) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text action-description",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(action.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-2 flex-shrink-0",
                                      attrs: {
                                        small: "",
                                        color: action.color,
                                        outlined: "",
                                        loading: _vm.loading[action.loadingKey],
                                        disabled:
                                          _vm.anyLoading ||
                                          (action.key === "avancieTenants" &&
                                            !_vm.hasAvancieIntegration),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.executeAction(action)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("execute")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              action.key === "avancieTenants" &&
                              _vm.avancieTenantsResults &&
                              _vm.avancieTenantsResults.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-2 ml-12 avancie-tenants-list",
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        {
                                          staticClass: "pa-0",
                                          attrs: { dense: "" },
                                        },
                                        _vm._l(
                                          _vm.avancieTenantsResults,
                                          function (tenant, index) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: tenant.id || index,
                                                staticClass: "px-0",
                                              },
                                              [
                                                _c(
                                                  "v-list-item-content",
                                                  { staticClass: "py-1" },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "text-body-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              tenant.name ||
                                                                tenant.code
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-caption",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(tenant.id)
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "ml-1 copy-icon",
                                                            attrs: {
                                                              "x-small": "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.copyToClipboard(
                                                                  tenant.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " mdi-content-copy "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : action.key === "avancieTenants" &&
                                  _vm.avancieTenants &&
                                  _vm.avancieTenantsResults.length === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-2 ml-12 text-caption grey--text",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("no-avancie-tenants")) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c("confirmation-dialog", {
        ref: "dialogRef",
        attrs: { "content-class": "devops-subdialog" },
      }),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "860",
            persistent: "",
            "content-class": "devops-subdialog devops-subdialog--scrollable",
          },
          model: {
            value: _vm.orphanReportDialog,
            callback: function ($$v) {
              _vm.orphanReportDialog = $$v
            },
            expression: "orphanReportDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3 orphan-report-card" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("orphan-report-title")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeOrphanReportDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c("div", { staticClass: "mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "text-caption font-weight-bold mb-1" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("orphan-report-select-category")) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-wrap" },
                      _vm._l(_vm.orphanCategories, function (cat) {
                        return _c(
                          "v-btn",
                          {
                            key: cat.category,
                            staticClass: "mr-2 mb-2",
                            attrs: {
                              small: "",
                              outlined: "",
                              color: _vm.orphanCategoryResults[cat.category]
                                ? "success"
                                : "primary",
                              loading: _vm.loadingCategory === cat.category,
                              disabled:
                                _vm.loading.orphanReport &&
                                _vm.loadingCategory !== cat.category,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.fetchOrphanReport(cat.category)
                              },
                            },
                          },
                          [
                            _vm.orphanCategoryResults[cat.category]
                              ? _c(
                                  "v-icon",
                                  { attrs: { left: "", small: "" } },
                                  [_vm._v(" mdi-check ")]
                                )
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("orphan-category-" + cat.category)
                                ) +
                                " "
                            ),
                            _c(
                              "span",
                              { staticClass: "ml-1 grey--text text--darken-1" },
                              [
                                _vm._v(
                                  "(" + _vm._s(cat.collections.length) + ")"
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ]),
                  _c("v-divider", { staticClass: "mb-4" }),
                  _vm.loading.orphanReport && !_vm.orphanReport
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-center py-8" },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                        ],
                        1
                      )
                    : _vm.orphanReport
                    ? _c(
                        "div",
                        { staticClass: "orphan-report-panel" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center justify-space-between flex-wrap mb-2",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-subtitle-2 font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("orphan-report-summary-title")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "mt-1",
                                  attrs: {
                                    small: "",
                                    color: "error",
                                    "text-color": "white",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.orphanReport.summary
                                          ?.cleanupEligibleFindings || 0
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "orphan-report-cleanup-candidates"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap orphan-report-metrics mb-2",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "orphan-report-metric" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-caption grey--text" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "orphan-report-scanned-documents"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.orphanReport.scannedDocuments ||
                                              0
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "orphan-report-metric" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-caption grey--text" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "orphan-report-total-findings"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.orphanReport.summary
                                              ?.totalOrphanFindings || 0
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.orphanByMissingReference.length
                            ? _c(
                                "div",
                                { staticClass: "mb-2" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-caption font-weight-bold mb-1",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "orphan-report-by-collection"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.orphanByMissingReference,
                                    function (group) {
                                      return _c(
                                        "div",
                                        {
                                          key: group.type,
                                          staticClass: "mb-3",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-caption font-weight-bold mb-1 d-flex align-center",
                                            },
                                            [
                                              group.type === "organization"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mr-1" },
                                                    [_vm._v("❌")]
                                                  )
                                                : group.type === "user-group"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mr-1" },
                                                    [_vm._v("👥")]
                                                  )
                                                : group.type === "voicemail"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mr-1" },
                                                    [_vm._v("📱")]
                                                  )
                                                : _c(
                                                    "span",
                                                    { staticClass: "mr-1" },
                                                    [_vm._v("⚠️")]
                                                  ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      `orphan-missing-${group.type}`
                                                    )
                                                  ) +
                                                  " (" +
                                                  _vm._s(group.total) +
                                                  ") "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ml-2" },
                                            _vm._l(
                                              group.columns,
                                              function (entry) {
                                                return _c(
                                                  "v-chip",
                                                  {
                                                    key: entry.collection,
                                                    staticClass: "mr-1 mb-1",
                                                    attrs: {
                                                      small: "",
                                                      clickable: "",
                                                      color:
                                                        group.type ===
                                                        "organization"
                                                          ? "error"
                                                          : "warning",
                                                      "text-color": "white",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectOrphanCollection(
                                                          entry.collection,
                                                          group.type
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          entry.collection
                                                        ) +
                                                        ": " +
                                                        _vm._s(entry.count) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.selectedCollectionFindings.length
                            ? _c(
                                "div",
                                {
                                  ref: "selectedCollectionPanel",
                                  staticClass:
                                    "mb-3 pa-3 blue-grey lighten-5 rounded",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between align-center mb-3",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            " 📋 " +
                                              _vm._s(
                                                _vm.selectedOrphanCollection
                                              ) +
                                              " (" +
                                              _vm._s(
                                                _vm.selectedCollectionFindings
                                                  .length
                                              ) +
                                              " " +
                                              _vm._s(_vm.$t("documents")) +
                                              ") "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { small: "", text: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.selectedOrphanCollection =
                                                null
                                              _vm.selectedOrphanMissingType =
                                                null
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("close")) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "orphan-collection-details",
                                      staticStyle: {
                                        "max-height": "400px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    _vm._l(
                                      _vm.selectedCollectionFindingsGrouped,
                                      function (group) {
                                        return _c(
                                          "div",
                                          {
                                            key: group.organizationId,
                                            staticClass: "mb-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-caption font-weight-bold pa-2 rounded",
                                                staticStyle: {
                                                  "background-color": "#eceff1",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "orphan-ghost-org-id"
                                                      )
                                                    ) +
                                                    ": "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-monospace",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        group.organizationId
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "pl-3 mt-1" },
                                              _vm._l(
                                                group.documents,
                                                function (doc) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: doc.documentId,
                                                      staticClass:
                                                        "text-caption mb-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            doc.documentId
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.uniqueGhostOrganizations.length
                            ? _c(
                                "v-expansion-panels",
                                {
                                  staticClass: "mb-3",
                                  model: {
                                    value: _vm.orphanGhostOrgExpanded,
                                    callback: function ($$v) {
                                      _vm.orphanGhostOrgExpanded = $$v
                                    },
                                    expression: "orphanGhostOrgExpanded",
                                  },
                                },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 👻 " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "orphan-ghost-org-ids"
                                                          )
                                                        ) +
                                                        " (" +
                                                        _vm._s(
                                                          _vm
                                                            .uniqueGhostOrganizations
                                                            .length
                                                        ) +
                                                        ") "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        365440060
                                      ),
                                    },
                                    [
                                      _c("v-expansion-panel-content", [
                                        _c(
                                          "div",
                                          { staticClass: "orphan-ghost-ids" },
                                          _vm._l(
                                            _vm.uniqueGhostOrganizations,
                                            function (orgId) {
                                              return _c(
                                                "div",
                                                {
                                                  key: orgId,
                                                  staticClass:
                                                    "text-caption font-monospace mb-1",
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(orgId) + " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.orphanFindingsPreview.length
                            ? _c(
                                "v-expansion-panels",
                                {
                                  staticClass: "mb-2",
                                  model: {
                                    value: _vm.orphanFindingsExpanded,
                                    callback: function ($$v) {
                                      _vm.orphanFindingsExpanded = $$v
                                    },
                                    expression: "orphanFindingsExpanded",
                                  },
                                },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-caption font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "orphan-report-findings-preview"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2305470217
                                      ),
                                    },
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        [
                                          _vm._l(
                                            _vm.orphanFindingsPreview,
                                            function (finding, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: `${finding.collection}-${finding.documentId}-${index}`,
                                                  staticClass:
                                                    "text-caption orphan-finding-line",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        finding.collection
                                                      ) +
                                                      "/" +
                                                      _vm._s(
                                                        finding.documentId
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        finding.missingReference
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm.orphanReport.findings?.length >
                                          _vm.orphanPreviewLimit
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-caption grey--text mt-1",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "orphan-report-preview-truncated",
                                                          {
                                                            count:
                                                              _vm.orphanReport
                                                                .findings
                                                                .length -
                                                              _vm.orphanPreviewLimit,
                                                          }
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "text-caption grey--text text-center py-6",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("orphan-report-select-category-hint")
                              ) +
                              " "
                          ),
                        ]
                      ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeOrphanReportDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center flex-wrap justify-end",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            color: "primary",
                            loading: _vm.loading.orphanReport,
                            disabled: !_vm.hasOrphanResults,
                          },
                          on: { click: _vm.refreshOrphanReport },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.migrateDialog,
            callback: function ($$v) {
              _vm.migrateDialog = $$v
            },
            expression: "migrateDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("migrate-conversations")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeMigrateDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "migrateForm",
                      model: {
                        value: _vm.migrateFormValid,
                        callback: function ($$v) {
                          _vm.migrateFormValid = $$v
                        },
                        expression: "migrateFormValid",
                      },
                    },
                    [
                      _c("v-autocomplete", {
                        staticClass: "mb-2",
                        attrs: {
                          items: _vm.fromPhoneNumberOptions,
                          label: _vm.$t("from-phone-number"),
                          rules: [_vm.rules.required],
                          loading: _vm.loadingFromPhones,
                          outlined: "",
                          dense: "",
                          "item-text": "label",
                          "item-value": "phoneNumber",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        class: {
                                          "warning--text": item.isUnassigned,
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(item.label) + " ")]
                                    ),
                                    _c("v-list-item-subtitle", [
                                      _vm._v(_vm._s(item.phoneNumber)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "selection",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "warning--text": item.isUnassigned,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.label) +
                                        " - " +
                                        _vm._s(item.phoneNumber) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.migrateData.from,
                          callback: function ($$v) {
                            _vm.$set(_vm.migrateData, "from", $$v)
                          },
                          expression: "migrateData.from",
                        },
                      }),
                      _c("v-select", {
                        attrs: {
                          items: _vm.toPhoneNumberOptions,
                          label: _vm.$t("to-phone-number"),
                          rules: [_vm.rules.required],
                          loading: _vm.loadingGroups,
                          outlined: "",
                          dense: "",
                          "item-text": "label",
                          "item-value": "phoneNumber",
                          "hide-details": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _vm._v(_vm._s(item.phoneNumber)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "selection",
                            fn: function ({ item }) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(item.label) +
                                      " - " +
                                      _vm._s(item.phoneNumber)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.migrateData.to,
                          callback: function ($$v) {
                            _vm.$set(_vm.migrateData, "to", $$v)
                          },
                          expression: "migrateData.to",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeMigrateDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        disabled: !_vm.migrateFormValid,
                        loading: _vm.loading.migrate,
                      },
                      on: { click: _vm.confirmMigrate },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.portabilityDialog,
            callback: function ($$v) {
              _vm.portabilityDialog = $$v
            },
            expression: "portabilityDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("portability-check")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closePortabilityDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "portabilityForm",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.portabilityFormValid,
                        callback: function ($$v) {
                          _vm.portabilityFormValid = $$v
                        },
                        expression: "portabilityFormValid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("source-phone-number"),
                          rules: [_vm.rules.required],
                          disabled: _vm.portabilityResult !== null,
                          outlined: "",
                          dense: "",
                          placeholder: "+15551234567",
                          "hide-details": "auto",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            _vm.portabilityFormValid &&
                              !_vm.portabilityResult &&
                              _vm.checkPortability()
                          },
                        },
                        model: {
                          value: _vm.portabilityPhone,
                          callback: function ($$v) {
                            _vm.portabilityPhone = $$v
                          },
                          expression: "portabilityPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.portabilityResult
                    ? _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "portability-section mb-4" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center mb-2" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-bold",
                                    },
                                    [_vm._v("Complete Porting")]
                                  ),
                                  _c("span", { staticClass: "ml-2 text-h6" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getPortingStatusEmoji(
                                            _vm.portabilityResult
                                              .portingPortability?.portable
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.portabilityResult.portingPortability
                                ?.notPortableReason
                                ? _c(
                                    "div",
                                    { staticClass: "ml-4 text-body-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "font-weight-bold black--text",
                                        },
                                        [_vm._v(" notPortableReason: ")]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.PORTABILITY_API_DOCS_URL,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.portabilityResult
                                                  .portingPortability
                                                  .notPortableReason
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("v-divider", { staticClass: "my-3" }),
                          _c("div", { staticClass: "portability-section" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center mb-2" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-subtitle-1 font-weight-bold",
                                  },
                                  [_vm._v("Hosted SMS Porting")]
                                ),
                                _c("span", { staticClass: "ml-2 text-h6" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getHostedSmsStatusEmoji(
                                          _vm.portabilityResult
                                            .hostedSmsPortability
                                            ?.eligibility_status
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                            _c("div", { staticClass: "ml-4 text-body-2" }, [
                              _vm.portabilityResult.hostedSmsPortability
                                ?.ineligibility_reason
                                ? _c("div", { staticClass: "mb-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold black--text",
                                      },
                                      [_vm._v(" ineligibility_reason: ")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.HOSTED_NUMBERS_DOCS_URL,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.portabilityResult
                                                .hostedSmsPortability
                                                .ineligibility_reason
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.portabilityResult.hostedSmsPortability
                                ?.eligibility_sub_status
                                ? _c("div", { staticClass: "mb-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold black--text",
                                      },
                                      [_vm._v(" eligibility_sub_status: ")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.HOSTED_NUMBERS_DOCS_URL,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.portabilityResult
                                                .hostedSmsPortability
                                                .eligibility_sub_status
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.portabilityResult.hostedSmsPortability
                                ?.next_step
                                ? _c("div", { staticClass: "mb-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold black--text",
                                      },
                                      [_vm._v(" next_step: ")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.HOSTED_NUMBERS_DOCS_URL,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.portabilityResult
                                                .hostedSmsPortability.next_step
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.portabilityResult.hostedSmsPortability
                                ?.phone_number_type
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold black--text",
                                      },
                                      [_vm._v(" phone_number_type: ")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.HOSTED_NUMBERS_DOCS_URL,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.portabilityResult
                                                .hostedSmsPortability
                                                .phone_number_type
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closePortabilityDialog },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.portabilityResult
                              ? _vm.$t("close")
                              : _vm.$t("cancel")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  !_vm.portabilityResult
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "px-4",
                          attrs: {
                            color: "primary",
                            disabled: !_vm.portabilityFormValid,
                            loading: _vm.loading.portabilityCheck,
                          },
                          on: { click: _vm.checkPortability },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("execute")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "700",
            persistent: "",
            "content-class": "devops-subdialog devops-subdialog--scrollable",
          },
          model: {
            value: _vm.phoneWebhooksDialog,
            callback: function ($$v) {
              _vm.phoneWebhooksDialog = $$v
            },
            expression: "phoneWebhooksDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3 phone-webhooks-card" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("phone-webhooks")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closePhoneWebhooksDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c("v-switch", {
                    staticClass: "mt-0 mb-4",
                    attrs: {
                      label: _vm.$t("phone-webhooks-all-orgs"),
                      disabled:
                        _vm.loading.phoneWebhooks || _vm.repairingWebhooks,
                      dense: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.phoneWebhooksAllOrgs,
                      callback: function ($$v) {
                        _vm.phoneWebhooksAllOrgs = $$v
                      },
                      expression: "phoneWebhooksAllOrgs",
                    },
                  }),
                  _vm.loading.phoneWebhooks && !_vm.phoneWebhooksResult
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-center py-8" },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                        ],
                        1
                      )
                    : _vm.phoneWebhooksResult
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-caption font-weight-bold mb-1",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("phone-webhooks-expected")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "text-caption font-monospace mb-1" },
                            [
                              _vm._v(
                                " statusCallback: " +
                                  _vm._s(
                                    _vm.phoneWebhooksResult.expected
                                      ?.statusCallback
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "text-caption font-monospace mb-3" },
                            [
                              _vm._v(
                                " voiceFallbackUrl: " +
                                  _vm._s(
                                    _vm.phoneWebhooksResult.expected
                                      ?.voiceFallbackUrl
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("v-divider", { staticClass: "mb-3" }),
                          !_vm.phoneWebhooksResult.mismatches?.length
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    type: "success",
                                    dense: "",
                                    outlined: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("phone-webhooks-no-mismatches")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-subtitle-2 font-weight-bold mb-2",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.phoneWebhooksResult.mismatches
                                              .length
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$t("phone-webhooks-mismatches")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.phoneWebhooksResult.mismatches,
                                    function (mismatch) {
                                      return _c(
                                        "div",
                                        {
                                          key: mismatch.sid,
                                          staticClass:
                                            "mb-3 pa-2 rounded blue-grey lighten-5",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-body-2 font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(mismatch.number) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption grey--text",
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        mismatch.organization
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-caption font-monospace",
                                            },
                                            [
                                              _vm._v(
                                                " statusCallback: " +
                                                  _vm._s(
                                                    mismatch.statusCallback ||
                                                      "—"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-caption font-monospace",
                                            },
                                            [
                                              _vm._v(
                                                " voiceFallbackUrl: " +
                                                  _vm._s(
                                                    mismatch.voiceFallbackUrl ||
                                                      "—"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                          _vm.phoneWebhooksResult.repaired
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    type: "success",
                                    dense: "",
                                    outlined: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("phone-webhooks-repaired", {
                                          count:
                                            _vm.phoneWebhooksResult.repaired,
                                        })
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(
                            _vm.phoneWebhooksResult.errors || [],
                            function (webhookError, index) {
                              return _c(
                                "v-alert",
                                {
                                  key: index,
                                  staticClass: "mt-2",
                                  attrs: {
                                    type: "error",
                                    dense: "",
                                    outlined: "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(webhookError) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closePhoneWebhooksDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            color: "primary",
                            loading: _vm.loading.phoneWebhooks,
                            disabled: _vm.repairingWebhooks,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.fetchPhoneWebhooks()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.phoneWebhooksResult
                                  ? _vm.$t("refresh")
                                  : _vm.$t("execute")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm.phoneWebhooksResult &&
                      _vm.phoneWebhooksResult.mismatches?.length
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "warning",
                                loading: _vm.repairingWebhooks,
                                disabled: _vm.loading.phoneWebhooks,
                              },
                              on: { click: _vm.repairPhoneWebhooks },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("phone-webhooks-repair")) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "800",
            persistent: "",
            "content-class": "devops-subdialog devops-subdialog--scrollable",
          },
          model: {
            value: _vm.oauth2DebugDialog,
            callback: function ($$v) {
              _vm.oauth2DebugDialog = $$v
            },
            expression: "oauth2DebugDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3 oauth2-debug-card" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("oauth2-debug")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeOAuth2DebugDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c("v-card-text", { staticClass: "pb-2" }, [
                _vm.loading.oauth2Debug
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-center py-4" },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "teal" },
                        }),
                      ],
                      1
                    )
                  : _vm.oauth2DebugResult && _vm.oauth2DebugResult.length === 0
                  ? _c(
                      "div",
                      { staticClass: "text-center py-4" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { size: "48", color: "grey lighten-1" } },
                          [_vm._v("mdi-email-off")]
                        ),
                        _c(
                          "div",
                          { staticClass: "text-body-1 grey--text mt-2" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("oauth2-debug-no-groups")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm.oauth2DebugResult
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-expansion-panels",
                          { attrs: { accordion: "" } },
                          _vm._l(_vm.oauth2DebugResult, function (group) {
                            return _c(
                              "v-expansion-panel",
                              { key: group.id },
                              [
                                _c("v-expansion-panel-header", [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      group.oauth
                                        ? [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "mr-3",
                                                                  attrs: {
                                                                    color:
                                                                      "error",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " mdi-alert-circle "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(group.oauth)),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        : group.emailValid === true &&
                                          _vm.hasOAuthWarning(group)
                                        ? [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-3",
                                                attrs: { color: "warning" },
                                              },
                                              [_vm._v("mdi-alert")]
                                            ),
                                          ]
                                        : group.emailValid === true
                                        ? [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-3",
                                                attrs: { color: "success" },
                                              },
                                              [_vm._v("mdi-check-circle")]
                                            ),
                                          ]
                                        : group.emailValid === false
                                        ? [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-3",
                                                attrs: { color: "error" },
                                              },
                                              [_vm._v("mdi-close-circle")]
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-3",
                                                attrs: { color: "grey" },
                                              },
                                              [_vm._v("mdi-help-circle")]
                                            ),
                                          ],
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "font-weight-medium",
                                            },
                                            [_vm._v(_vm._s(group.label || "—"))]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-caption grey--text",
                                            },
                                            [_vm._v(_vm._s(group.email))]
                                          ),
                                          _vm._l(
                                            group.credentialIds || [],
                                            function (cred) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "id-" + cred.id,
                                                  staticClass:
                                                    "d-flex align-center",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-caption grey--text text--lighten-1",
                                                      staticStyle: {
                                                        "font-size":
                                                          "10px !important",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(cred.id))]
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.copyToClipboard(
                                                            cred.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            color: "grey",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-content-copy"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _c("v-spacer"),
                                      group.emailType
                                        ? _c(
                                            "v-chip",
                                            {
                                              staticClass: "mr-4",
                                              attrs: {
                                                small: "",
                                                color:
                                                  group.emailType === "google"
                                                    ? "red"
                                                    : "blue",
                                                "text-color": "white",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    group.emailType === "google"
                                                      ? "Google"
                                                      : "Microsoft"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._l(
                                        group.credentialIds || [],
                                        function (cred) {
                                          return _c(
                                            "v-tooltip",
                                            {
                                              key: cred.id,
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                                attrs: {
                                                                  icon: "",
                                                                  small: "",
                                                                  color:
                                                                    "error",
                                                                  loading:
                                                                    _vm
                                                                      .deleteCredentialLoading[
                                                                      cred.id
                                                                    ],
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.deleteOAuthCredential(
                                                                        group,
                                                                        cred
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-delete"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "oauth2-debug-delete-credential",
                                                      { type: cred.type }
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                                _c(
                                  "v-expansion-panel-content",
                                  [
                                    group.oauth
                                      ? _c(
                                          "v-alert",
                                          {
                                            staticClass: "mb-4",
                                            attrs: {
                                              type: "error",
                                              prominent: "",
                                              dense: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-oauth-error"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "code",
                                              {
                                                staticClass:
                                                  "oauth-error-code error--text text--darken-2 font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(group.oauth) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    group.emailType === "google" &&
                                    group.userInfo
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-google-user-info"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-card",
                                              {
                                                staticClass: "pa-3",
                                                attrs: { outlined: "" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center oauth-user-card",
                                                  },
                                                  [
                                                    _c(
                                                      "v-avatar",
                                                      {
                                                        staticClass: "mr-4",
                                                        attrs: { size: "56" },
                                                      },
                                                      [
                                                        group.userInfo.picture
                                                          ? _c("v-img", {
                                                              attrs: {
                                                                src: group
                                                                  .userInfo
                                                                  .picture,
                                                                alt: group
                                                                  .userInfo
                                                                  .name,
                                                              },
                                                            })
                                                          : _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  size: "56",
                                                                  color:
                                                                    "grey lighten-1",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-account-circle"
                                                                ),
                                                              ]
                                                            ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex-grow-1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center mb-1",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-body-1 font-weight-medium",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    group
                                                                      .userInfo
                                                                      .name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            group.userInfo
                                                              .verified_email
                                                              ? _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "ml-2",
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "success",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " mdi-check-decagram "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-body-2 grey--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  group.userInfo
                                                                    .email
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        group.userInfo.hd
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-domain"
                                                                      )
                                                                    ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      group
                                                                        .userInfo
                                                                        .hd
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "oauth-id-info",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "oauth2-debug-google-id"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "code",
                                                          {
                                                            staticClass:
                                                              "text-caption",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  group.userInfo
                                                                    .id
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : group.emailType === "google" &&
                                        !group.userInfo
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-google-user-info"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-alert",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  outlined: "",
                                                  icon: "mdi-account-alert",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-no-user-info"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    group.emailType === "google" &&
                                    group.tokenScopes &&
                                    group.tokenScopes.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-token-scopes"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-card",
                                              {
                                                staticClass: "pa-3",
                                                attrs: { outlined: "" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-wrap",
                                                  },
                                                  _vm._l(
                                                    group.tokenScopes,
                                                    function (scope) {
                                                      return _c(
                                                        "v-chip",
                                                        {
                                                          key: scope,
                                                          staticClass:
                                                            "mr-2 mb-2",
                                                          attrs: {
                                                            small: "",
                                                            outlined: "",
                                                            color: "red",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatScope(
                                                                  scope
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : group.emailType === "google" &&
                                        (!group.tokenScopes ||
                                          group.tokenScopes.length === 0)
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-token-scopes"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-alert",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  outlined: "",
                                                  icon: "mdi-key-alert",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-no-token-scopes"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    group.emailType === "google" &&
                                    group.watchStatus
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-space-between mb-2",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2 font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-gmail-watch-status"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "red",
                                                      outlined: "",
                                                      loading:
                                                        _vm.resubscribeLoading[
                                                          group.id
                                                        ],
                                                      disabled:
                                                        _vm.anyResubscribeLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.forceResubscribe(
                                                          group.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          left: "",
                                                        },
                                                      },
                                                      [_vm._v("mdi-refresh")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-resubscribe"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-card",
                                              {
                                                staticClass: "pa-3",
                                                class:
                                                  _vm.getWatchStatusCardClass(
                                                    group.watchStatus
                                                  ),
                                                attrs: { outlined: "" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-wrap",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "watch-status-field mr-6 mb-2",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "oauth2-debug-watch-active"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color: group
                                                                    .watchStatus
                                                                    .watchActive
                                                                    ? "success"
                                                                    : "error",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .watchStatus
                                                                        .watchActive
                                                                        ? "mdi-check-circle"
                                                                        : "mdi-close-circle"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-body-2 font-weight-medium",
                                                                class: group
                                                                  .watchStatus
                                                                  .watchActive
                                                                  ? "success--text"
                                                                  : "error--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .watchStatus
                                                                        .watchActive
                                                                        ? _vm.$t(
                                                                            "yes"
                                                                          )
                                                                        : _vm.$t(
                                                                            "no"
                                                                          )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    group.watchStatus
                                                      .responseTimeMs
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "watch-status-field mr-6 mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-response-time"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-center",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "info",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-timer-outline"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-body-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.formatResponseTime(
                                                                            group
                                                                              .watchStatus
                                                                              .responseTimeMs
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "watch-status-field mr-6 mb-2",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "oauth2-debug-test-success"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color: group
                                                                    .watchStatus
                                                                    .success
                                                                    ? "success"
                                                                    : "error",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .watchStatus
                                                                        .success
                                                                        ? "mdi-check"
                                                                        : "mdi-close"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-body-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .watchStatus
                                                                        .success
                                                                        ? _vm.$t(
                                                                            "yes"
                                                                          )
                                                                        : _vm.$t(
                                                                            "no"
                                                                          )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    group.watchStatus.messageId
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "watch-status-field-full mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-message-id"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "code",
                                                              {
                                                                staticClass:
                                                                  "text-body-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .watchStatus
                                                                        .messageId
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    group.watchStatus.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "watch-status-field-full",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-error"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-body-2 error--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .watchStatus
                                                                        .error
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : group.emailType === "google" &&
                                        !group.watchStatus
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-space-between mb-2",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2 font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-gmail-watch-status"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "red",
                                                      outlined: "",
                                                      loading:
                                                        _vm.resubscribeLoading[
                                                          group.id
                                                        ],
                                                      disabled:
                                                        _vm.anyResubscribeLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.forceResubscribe(
                                                          group.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          left: "",
                                                        },
                                                      },
                                                      [_vm._v("mdi-refresh")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-resubscribe"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-alert",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  outlined: "",
                                                  icon: "mdi-eye-off",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-no-watch-status"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    group.emailType === "MICROSOFT" &&
                                    group.userInfo
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-microsoft-user-info"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-card",
                                              {
                                                staticClass: "pa-3",
                                                attrs: { outlined: "" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center oauth-user-card",
                                                  },
                                                  [
                                                    _c(
                                                      "v-avatar",
                                                      {
                                                        staticClass: "mr-4",
                                                        attrs: {
                                                          size: "56",
                                                          color:
                                                            "blue lighten-4",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              size: "32",
                                                              color: "blue",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-microsoft"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex-grow-1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center mb-1",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-body-1 font-weight-medium",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .userInfo
                                                                        .displayName
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-body-2 grey--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  group.userInfo
                                                                    .mail ||
                                                                    group
                                                                      .userInfo
                                                                      .userPrincipalName
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        group.userInfo.jobTitle
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      group
                                                                        .userInfo
                                                                        .jobTitle
                                                                    ) +
                                                                    " "
                                                                ),
                                                                group.userInfo
                                                                  .officeLocation
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " • " +
                                                                          _vm._s(
                                                                            group
                                                                              .userInfo
                                                                              .officeLocation
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        group.userInfo
                                                          .preferredLanguage
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-language"
                                                                      )
                                                                    ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      group
                                                                        .userInfo
                                                                        .preferredLanguage
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "oauth-id-info",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "oauth2-debug-microsoft-id"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "code",
                                                          {
                                                            staticClass:
                                                              "text-caption",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  group.userInfo
                                                                    .id
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        group.userInfo
                                                          .mobilePhone
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mt-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption grey--text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "oauth2-debug-mobile"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          group
                                                                            .userInfo
                                                                            .mobilePhone
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : group.emailType === "MICROSOFT" &&
                                        !group.userInfo
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-microsoft-user-info"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-alert",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  outlined: "",
                                                  icon: "mdi-account-alert",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-no-user-info"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    group.emailType === "MICROSOFT" &&
                                    group.tokenScopes &&
                                    group.tokenScopes.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-token-scopes"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-card",
                                              {
                                                staticClass: "pa-3",
                                                attrs: { outlined: "" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-wrap",
                                                  },
                                                  _vm._l(
                                                    group.tokenScopes,
                                                    function (scope) {
                                                      return _c(
                                                        "v-chip",
                                                        {
                                                          key: scope,
                                                          staticClass:
                                                            "mr-2 mb-2",
                                                          attrs: {
                                                            small: "",
                                                            outlined: "",
                                                            color: "blue",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(scope) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : group.emailType === "MICROSOFT" &&
                                        (!group.tokenScopes ||
                                          group.tokenScopes.length === 0)
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 font-weight-bold mb-2",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "oauth2-debug-token-scopes"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-alert",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  outlined: "",
                                                  icon: "mdi-key-alert",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-no-token-scopes"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    group.emailType === "MICROSOFT" &&
                                    group.subscriptions
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-space-between mb-2",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2 font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-subscriptions"
                                                          )
                                                        ) +
                                                        " (" +
                                                        _vm._s(
                                                          _vm.getSubscriptionCount(
                                                            group.subscriptions
                                                          )
                                                        ) +
                                                        ") "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "blue",
                                                      outlined: "",
                                                      loading:
                                                        _vm.resubscribeLoading[
                                                          group.id
                                                        ],
                                                      disabled:
                                                        _vm.anyResubscribeLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.forceResubscribe(
                                                          group.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          left: "",
                                                        },
                                                      },
                                                      [_vm._v("mdi-refresh")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-resubscribe"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.getSubscriptionCount(
                                              group.subscriptions
                                            ) === 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "grey--text text-body-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-no-active-subscriptions"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._l(
                                              _vm.getSubscriptions(
                                                group.subscriptions
                                              ),
                                              function (subscription) {
                                                return _c(
                                                  "v-card",
                                                  {
                                                    key: subscription.id,
                                                    staticClass: "mb-2 pa-3",
                                                    attrs: { outlined: "" },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-wrap",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "subscription-field mr-4 mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-resource"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-body-2 font-weight-medium",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.formatResource(
                                                                        subscription.resource
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "subscription-field mr-4 mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-change-type"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-chip",
                                                              {
                                                                attrs: {
                                                                  "x-small": "",
                                                                  color:
                                                                    _vm.getChangeTypeColor(
                                                                      subscription.changeType
                                                                    ),
                                                                  "text-color":
                                                                    "white",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      subscription.changeType
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "subscription-field mr-4 mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-expiration"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-center",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      color:
                                                                        _vm.isExpired(
                                                                          subscription.expirationDateTime
                                                                        )
                                                                          ? "error"
                                                                          : "success",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.isExpired(
                                                                            subscription.expirationDateTime
                                                                          )
                                                                            ? "mdi-alert"
                                                                            : "mdi-check"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-body-2",
                                                                    class: {
                                                                      "error--text":
                                                                        _vm.isExpired(
                                                                          subscription.expirationDateTime
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.formatDateTime(
                                                                            subscription.expirationDateTime
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "subscription-field-full mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-notification-url"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-body-2 text-truncate",
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "100%",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      subscription.notificationUrl
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "subscription-field-full",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "oauth2-debug-lifecycle-url"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-body-2 text-truncate",
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "100%",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      subscription.lifecycleNotificationUrl ||
                                                                        "—"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : group.emailType === "MICROSOFT" &&
                                        !group.subscriptions
                                      ? _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-space-between mb-2",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2 font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-subscriptions"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "blue",
                                                      outlined: "",
                                                      loading:
                                                        _vm.resubscribeLoading[
                                                          group.id
                                                        ],
                                                      disabled:
                                                        _vm.anyResubscribeLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.forceResubscribe(
                                                          group.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          left: "",
                                                        },
                                                      },
                                                      [_vm._v("mdi-refresh")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-resubscribe"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-alert",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  outlined: "",
                                                  icon: "mdi-bell-off",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "oauth2-debug-no-subscriptions-data"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !group.oauth &&
                                    group.emailType !== "google" &&
                                    group.emailType !== "MICROSOFT"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "grey--text text-body-2",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "oauth2-debug-no-additional-info"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "primary" },
                      on: { click: _vm.closeOAuth2DebugDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.createAgentDialog,
            callback: function ($$v) {
              _vm.createAgentDialog = $$v
            },
            expression: "createAgentDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("create-agent")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeCreateAgentDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "createAgentForm",
                      model: {
                        value: _vm.createAgentFormValid,
                        callback: function ($$v) {
                          _vm.createAgentFormValid = $$v
                        },
                        expression: "createAgentFormValid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: _vm.$t("organization-id"),
                          rules: [_vm.rules.required],
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.createAgentData.organizationId,
                          callback: function ($$v) {
                            _vm.$set(_vm.createAgentData, "organizationId", $$v)
                          },
                          expression: "createAgentData.organizationId",
                        },
                      }),
                      _c("v-select", {
                        staticClass: "mb-2 text-capitalize",
                        attrs: {
                          items: _vm.erpTypes,
                          label: _vm.$t("erp-type"),
                          rules: [_vm.rules.required],
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.createAgentData.erpType,
                          callback: function ($$v) {
                            _vm.$set(_vm.createAgentData, "erpType", $$v)
                          },
                          expression: "createAgentData.erpType",
                        },
                      }),
                      _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: _vm.$t("db-server"),
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.createAgentData.dbServer,
                          callback: function ($$v) {
                            _vm.$set(_vm.createAgentData, "dbServer", $$v)
                          },
                          expression: "createAgentData.dbServer",
                        },
                      }),
                      _c("v-switch", {
                        staticClass: "mt-0 mb-2",
                        attrs: {
                          label: _vm.$t("enabled"),
                          inset: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.createAgentData.enabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.createAgentData, "enabled", $$v)
                          },
                          expression: "createAgentData.enabled",
                        },
                      }),
                      _c("v-switch", {
                        staticClass: "mt-0",
                        attrs: {
                          label: _vm.$t("download-installer"),
                          inset: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.createAgentData.downloadFile,
                          callback: function ($$v) {
                            _vm.$set(_vm.createAgentData, "downloadFile", $$v)
                          },
                          expression: "createAgentData.downloadFile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeCreateAgentDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        disabled: !_vm.createAgentFormValid,
                        loading: _vm.loading.createAgent,
                      },
                      on: { click: _vm.createAgent },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.createErpIntegrationDialog,
            callback: function ($$v) {
              _vm.createErpIntegrationDialog = $$v
            },
            expression: "createErpIntegrationDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("create-erp-integration")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeCreateErpIntegrationDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "createErpIntegrationForm",
                      model: {
                        value: _vm.createErpIntegrationFormValid,
                        callback: function ($$v) {
                          _vm.createErpIntegrationFormValid = $$v
                        },
                        expression: "createErpIntegrationFormValid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: _vm.$t("organization-id"),
                          rules: [_vm.rules.required],
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.createErpIntegrationData.organizationId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createErpIntegrationData,
                              "organizationId",
                              $$v
                            )
                          },
                          expression: "createErpIntegrationData.organizationId",
                        },
                      }),
                      _c("v-select", {
                        staticClass: "mb-2 text-capitalize",
                        attrs: {
                          items: _vm.erpTypes,
                          label: _vm.$t("erp-type"),
                          rules: [_vm.rules.required],
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.createErpIntegrationData.erpType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createErpIntegrationData,
                              "erpType",
                              $$v
                            )
                          },
                          expression: "createErpIntegrationData.erpType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeCreateErpIntegrationDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        disabled: !_vm.createErpIntegrationFormValid,
                        loading: _vm.loading.createErpIntegration,
                      },
                      on: { click: _vm.createErpIntegration },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.createConnectorDialog,
            callback: function ($$v) {
              _vm.createConnectorDialog = $$v
            },
            expression: "createConnectorDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("connector.create-action-title")) + " "
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeCreateConnectorDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "createConnectorForm",
                      model: {
                        value: _vm.createConnectorFormValid,
                        callback: function ($$v) {
                          _vm.createConnectorFormValid = $$v
                        },
                        expression: "createConnectorFormValid",
                      },
                    },
                    [
                      _c("organization-search-select", {
                        staticClass: "mb-2",
                        attrs: {
                          organizations: _vm.connectorOrganizations,
                          label: _vm.$t("connector.organization"),
                          rules: [_vm.rules.required],
                          loading: _vm.loadingConnectorOrganizations,
                        },
                        model: {
                          value: _vm.createConnectorData.organizationId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createConnectorData,
                              "organizationId",
                              $$v
                            )
                          },
                          expression: "createConnectorData.organizationId",
                        },
                      }),
                      _c("v-select", {
                        staticClass: "mb-2",
                        attrs: {
                          items: _vm.connectorTypes,
                          "item-value": "type",
                          "item-text": "label",
                          label: _vm.$t("connector.type"),
                          rules: [_vm.rules.required],
                          loading: _vm.loadingConnectorTypes,
                          "no-data-text": _vm.$t("no-data"),
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.createConnectorData.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.createConnectorData, "type", $$v)
                          },
                          expression: "createConnectorData.type",
                        },
                      }),
                      _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: _vm.$t("connector.crm-id"),
                          rules: [_vm.rules.required],
                          outlined: "",
                          dense: "",
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.trimConnectorField("crmId")
                          },
                        },
                        model: {
                          value: _vm.createConnectorData.crmId,
                          callback: function ($$v) {
                            _vm.$set(_vm.createConnectorData, "crmId", $$v)
                          },
                          expression: "createConnectorData.crmId",
                        },
                      }),
                      _c("v-text-field", {
                        staticClass: "mb-3",
                        attrs: {
                          label: _vm.$t("connector.username"),
                          hint: _vm.$t("connector.username-hint"),
                          "persistent-hint": "",
                          outlined: "",
                          dense: "",
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.trimConnectorField("username")
                          },
                        },
                        model: {
                          value: _vm.createConnectorData.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.createConnectorData, "username", $$v)
                          },
                          expression: "createConnectorData.username",
                        },
                      }),
                      _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: _vm.$t("connector.password"),
                          hint: _vm.$t("connector.password-hint"),
                          "persistent-hint": "",
                          type: "password",
                          outlined: "",
                          dense: "",
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.trimConnectorField("password")
                          },
                        },
                        model: {
                          value: _vm.createConnectorData.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.createConnectorData, "password", $$v)
                          },
                          expression: "createConnectorData.password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeCreateConnectorDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        disabled:
                          !_vm.createConnectorFormValid ||
                          _vm.loading.createConnector,
                        loading: _vm.loading.createConnector,
                      },
                      on: { click: _vm.createConnector },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", "content-class": "devops-subdialog" },
          model: {
            value: _vm.licenseKeyDialog,
            callback: function ($$v) {
              _vm.licenseKeyDialog = $$v
            },
            expression: "licenseKeyDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("agent-license-key")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.licenseKeyDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: { type: "info", text: "", dense: "" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("agent-license-key-info")) + " "
                      ),
                    ]
                  ),
                  _vm.agentLicenseAgentId
                    ? _c("v-text-field", {
                        attrs: {
                          value: _vm.agentLicenseAgentId,
                          label: _vm.$t("agent-id"),
                          outlined: "",
                          dense: "",
                          readonly: "",
                          "append-icon": "mdi-content-copy",
                        },
                        on: {
                          "click:append": function ($event) {
                            return _vm.copyToClipboard(_vm.agentLicenseAgentId)
                          },
                        },
                      })
                    : _vm._e(),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("license-key"),
                      outlined: "",
                      dense: "",
                      readonly: "",
                      "append-icon": "mdi-content-copy",
                    },
                    on: { "click:append": _vm.copyLicenseKey },
                    model: {
                      value: _vm.agentLicenseKey,
                      callback: function ($$v) {
                        _vm.agentLicenseKey = $$v
                      },
                      expression: "agentLicenseKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.licenseKeyDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            fullscreen: _vm.$vuetify.breakpoint.xs,
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.twilioRecordingsDialog,
            callback: function ($$v) {
              _vm.twilioRecordingsDialog = $$v
            },
            expression: "twilioRecordingsDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "twilio-recordings-card" },
            [
              _c(
                "v-card-title",
                {
                  staticClass:
                    "text-h6 font-weight-bold py-4 px-4 d-flex align-center",
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "orange darken-2" },
                    },
                    [_vm._v("mdi-microphone")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("twilio-recordings")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeTwilioRecordingsDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "py-4" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "twilioRecordingsForm",
                      model: {
                        value: _vm.twilioRecordingsFormValid,
                        callback: function ($$v) {
                          _vm.twilioRecordingsFormValid = $$v
                        },
                        expression: "twilioRecordingsFormValid",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-subtitle-2 font-weight-bold mb-3 d-flex align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "", color: "primary" },
                            },
                            [_vm._v("mdi-calendar-range")]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("twilio-recordings-date-range")) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "startDateMenu",
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "twilio-recordings-start-date"
                                                    ),
                                                    rules: [_vm.rules.required],
                                                    outlined: "",
                                                    dense: "",
                                                    readonly: "",
                                                    "hide-details": "auto",
                                                    "prepend-inner-icon":
                                                      "mdi-calendar",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.twilioRecordingsData
                                                        .startDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.twilioRecordingsData,
                                                        "startDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "twilioRecordingsData.startDate",
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                  model: {
                                    value: _vm.startDateMenu,
                                    callback: function ($$v) {
                                      _vm.startDateMenu = $$v
                                    },
                                    expression: "startDateMenu",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      max:
                                        _vm.twilioRecordingsData.endDate ||
                                        _vm.today,
                                      "no-title": "",
                                      scrollable: "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.startDateMenu = false
                                      },
                                    },
                                    model: {
                                      value: _vm.twilioRecordingsData.startDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.twilioRecordingsData,
                                          "startDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "twilioRecordingsData.startDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("twilio-recordings-start-time"),
                                  rules: [_vm.rules.required],
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  type: "time",
                                  "prepend-inner-icon": "mdi-clock-outline",
                                },
                                model: {
                                  value: _vm.twilioRecordingsData.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.twilioRecordingsData,
                                      "startTime",
                                      $$v
                                    )
                                  },
                                  expression: "twilioRecordingsData.startTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-1", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "endDateMenu",
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "twilio-recordings-end-date"
                                                    ),
                                                    rules: [_vm.rules.required],
                                                    outlined: "",
                                                    dense: "",
                                                    readonly: "",
                                                    "hide-details": "auto",
                                                    "prepend-inner-icon":
                                                      "mdi-calendar",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.twilioRecordingsData
                                                        .endDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.twilioRecordingsData,
                                                        "endDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "twilioRecordingsData.endDate",
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                  model: {
                                    value: _vm.endDateMenu,
                                    callback: function ($$v) {
                                      _vm.endDateMenu = $$v
                                    },
                                    expression: "endDateMenu",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      min: _vm.twilioRecordingsData.startDate,
                                      max: _vm.today,
                                      "no-title": "",
                                      scrollable: "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.endDateMenu = false
                                      },
                                    },
                                    model: {
                                      value: _vm.twilioRecordingsData.endDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.twilioRecordingsData,
                                          "endDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "twilioRecordingsData.endDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("twilio-recordings-end-time"),
                                  rules: [_vm.rules.required],
                                  outlined: "",
                                  dense: "",
                                  type: "time",
                                  "prepend-inner-icon": "mdi-clock-outline",
                                },
                                model: {
                                  value: _vm.twilioRecordingsData.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.twilioRecordingsData,
                                      "endTime",
                                      $$v
                                    )
                                  },
                                  expression: "twilioRecordingsData.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-subtitle-2 font-weight-bold mt-1 mb-2 d-flex align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "", color: "primary" },
                            },
                            [_vm._v("mdi-earth")]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("twilio-recordings-timezone")) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c("v-select", {
                        attrs: {
                          items: _vm.timezoneOptions,
                          label: _vm.$t("twilio-recordings-select-timezone"),
                          outlined: "",
                          dense: "",
                          "prepend-inner-icon": "mdi-map-clock",
                          "item-text": "label",
                          "item-value": "value",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                    _c(
                                      "v-list-item-subtitle",
                                      { staticClass: "text-caption" },
                                      [_vm._v(" " + _vm._s(item.value) + " ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.twilioRecordingsData.timezone,
                          callback: function ($$v) {
                            _vm.$set(_vm.twilioRecordingsData, "timezone", $$v)
                          },
                          expression: "twilioRecordingsData.timezone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.twilioRecordingsResults
                    ? _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c("v-divider", { staticClass: "mb-4" }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center justify-space-between mb-2",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-subtitle-2 font-weight-bold d-flex align-center",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "success" },
                                    },
                                    [_vm._v("mdi-playlist-music")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("twilio-recordings-results")
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        small: "",
                                        color: "orange darken-2",
                                        outlined: "",
                                        loading: _vm.downloadingAllRecordings,
                                        disabled:
                                          _vm.filteredTwilioRecordings
                                            .length === 0 ||
                                          _vm.downloadingAllRecordings,
                                      },
                                      on: { click: _vm.downloadAllRecordings },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-download-multiple")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "twilio-recordings-download-all"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        small: "",
                                        color: "primary",
                                        "text-color": "white",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.filteredTwilioRecordings.length
                                          ) +
                                          " / " +
                                          _vm._s(
                                            _vm.twilioRecordingsResults.length
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("v-text-field", {
                            staticClass: "mb-2",
                            attrs: {
                              placeholder: _vm.$t(
                                "twilio-recordings-search-phone"
                              ),
                              "prepend-inner-icon": "mdi-magnify",
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.twilioRecordingsSearch,
                              callback: function ($$v) {
                                _vm.twilioRecordingsSearch = $$v
                              },
                              expression: "twilioRecordingsSearch",
                            },
                          }),
                          _vm.filteredTwilioRecordings.length === 0
                            ? _c(
                                "div",
                                { staticClass: "text-center py-4" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "48",
                                        color: "grey lighten-1",
                                      },
                                    },
                                    [_vm._v("mdi-microphone-off")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-body-2 grey--text mt-2",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "twilio-recordings-no-results"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "recordings-list" },
                                _vm._l(
                                  _vm.filteredTwilioRecordings,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.sid,
                                        staticClass:
                                          "recording-item d-flex align-center py-2 px-3",
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mr-2 flex-shrink-0",
                                            attrs: {
                                              icon: "",
                                              small: "",
                                              color: "orange darken-2",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downloadRecording(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-download")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-grow-1 min-width-0 overflow-hidden",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-body-2 text-truncate",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.dateCreated)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-caption grey--text ml-2 flex-shrink-0",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatDuration(
                                                          item.duration
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-caption grey--text d-flex align-center",
                                                staticStyle: {
                                                  "max-width": "100%",
                                                },
                                              },
                                              [
                                                item.from
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-truncate",
                                                        staticStyle: {
                                                          "max-width": "45%",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.from)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "mx-1 flex-shrink-0",
                                                    attrs: { "x-small": "" },
                                                  },
                                                  [_vm._v("mdi-arrow-right")]
                                                ),
                                                item.to
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-truncate",
                                                        staticStyle: {
                                                          "max-width": "45%",
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(item.to))]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-chip",
                                          {
                                            staticClass: "ml-2 flex-shrink-0",
                                            attrs: {
                                              "x-small": "",
                                              color:
                                                _vm.getRecordingStatusColor(
                                                  item.status
                                                ),
                                              "text-color": "white",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.status) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 py-4 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeTwilioRecordingsDialog },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.twilioRecordingsResults
                              ? _vm.$t("close")
                              : _vm.$t("cancel")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        disabled: !_vm.twilioRecordingsFormValid,
                        loading: _vm.loading.twilioRecordings,
                      },
                      on: { click: _vm.fetchTwilioRecordings },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-magnify"),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("twilio-recordings-search")) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.callerIdDialog,
            callback: function ($$v) {
              _vm.callerIdDialog = $$v
            },
            expression: "callerIdDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("caller-id-title")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeCallerIdDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c("v-card-text", { staticClass: "pb-2" }, [
                !_vm.callerIdResult
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-form",
                          {
                            ref: "callerIdForm",
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                              },
                            },
                            model: {
                              value: _vm.callerIdFormValid,
                              callback: function ($$v) {
                                _vm.callerIdFormValid = $$v
                              },
                              expression: "callerIdFormValid",
                            },
                          },
                          [
                            _c("v-text-field", {
                              staticClass: "mb-3",
                              attrs: {
                                label: _vm.$t("caller-id-phone"),
                                rules: [
                                  _vm.rules.required,
                                  _vm.rules.e164Phone,
                                ],
                                outlined: "",
                                dense: "",
                                placeholder: "+15551234567",
                                "hide-details": "auto",
                              },
                              model: {
                                value: _vm.callerIdPhone,
                                callback: function ($$v) {
                                  _vm.callerIdPhone = $$v
                                },
                                expression: "callerIdPhone",
                              },
                            }),
                            _c("v-text-field", {
                              staticClass: "mb-1",
                              attrs: {
                                label: _vm.$t("caller-id-extension"),
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                              },
                              model: {
                                value: _vm.callerIdExtension,
                                callback: function ($$v) {
                                  _vm.callerIdExtension = $$v
                                },
                                expression: "callerIdExtension",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-caption grey--text mb-3 ml-1",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("caller-id-extension-hint")) +
                                    " "
                                ),
                              ]
                            ),
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("caller-id-friendly-name"),
                                outlined: "",
                                dense: "",
                                readonly: "",
                                "hide-details": "auto",
                              },
                              model: {
                                value: _vm.callerIdFriendlyName,
                                callback: function ($$v) {
                                  _vm.callerIdFriendlyName = $$v
                                },
                                expression: "callerIdFriendlyName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "text-body-2 text-center mb-3" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("caller-id-code-instructions")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "caller-id-code-box mb-4" },
                        _vm._l(
                          String(_vm.callerIdResult.validationCode).split(""),
                          function (digit, i) {
                            return _c(
                              "span",
                              { key: i, staticClass: "caller-id-digit" },
                              [_vm._v(" " + _vm._s(digit) + " ")]
                            )
                          }
                        ),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex align-center justify-center" },
                        [
                          _vm.callerIdStatus === "pending"
                            ? [
                                _c("v-progress-circular", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    indeterminate: "",
                                    color: "primary",
                                    size: "24",
                                  },
                                }),
                                _c("span", { staticClass: "text-body-1" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("caller-id-status-pending"))
                                  ),
                                ]),
                              ]
                            : _vm.callerIdStatus === "success"
                            ? [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "success" },
                                  },
                                  [_vm._v("mdi-check-circle")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-body-1 success--text font-weight-bold",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("caller-id-status-success")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm.callerIdStatus === "failed"
                            ? [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "error" },
                                  },
                                  [_vm._v("mdi-close-circle")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-body-1 error--text font-weight-bold",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("caller-id-status-failed")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm.callerIdStatus === "expired"
                            ? [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "warning" },
                                  },
                                  [_vm._v("mdi-clock-alert")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-body-1 warning--text font-weight-bold",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("caller-id-status-expired")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm.callerIdStatus === "failed" ||
                      _vm.callerIdStatus === "expired"
                        ? _c(
                            "div",
                            { staticClass: "d-flex justify-center mt-4" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    loading: _vm.loading.callerIdValidation,
                                  },
                                  on: { click: _vm.retryCallerIdValidation },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-refresh")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("caller-id-try-again")) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
              ]),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeCallerIdDialog },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.callerIdResult
                              ? _vm.$t("close")
                              : _vm.$t("cancel")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  !_vm.callerIdResult
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "px-4",
                          attrs: {
                            color: "primary",
                            disabled: !_vm.callerIdFormValid,
                            loading: _vm.loading.callerIdValidation,
                          },
                          on: { click: _vm.submitCallerIdValidation },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("caller-id-validate")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "550",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.transferPhoneDialog,
            callback: function ($$v) {
              _vm.transferPhoneDialog = $$v
            },
            expression: "transferPhoneDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("transfer-phone-number")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeTransferPhoneDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "transferPhoneForm",
                      model: {
                        value: _vm.transferPhoneFormValid,
                        callback: function ($$v) {
                          _vm.transferPhoneFormValid = $$v
                        },
                        expression: "transferPhoneFormValid",
                      },
                    },
                    [
                      _c("v-autocomplete", {
                        staticClass: "mb-2",
                        attrs: {
                          items: _vm.transferPhoneAccountOptions,
                          label: _vm.$t("transfer-phone-source-account"),
                          rules: [_vm.rules.required],
                          loading: _vm.loadingTransferPhoneAccounts,
                          outlined: "",
                          dense: "",
                          "item-text": "label",
                          "item-value": "accountSid",
                          "hide-details": "auto",
                        },
                        on: { change: _vm.onSourceAccountChange },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _vm._v(_vm._s(item.accountSid)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.transferPhoneData.sourceAccountSid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.transferPhoneData,
                              "sourceAccountSid",
                              $$v
                            )
                          },
                          expression: "transferPhoneData.sourceAccountSid",
                        },
                      }),
                      _c("v-autocomplete", {
                        staticClass: "mb-2",
                        attrs: {
                          items: _vm.transferPhoneAccountOptions,
                          label: _vm.$t("transfer-phone-destination-account"),
                          rules: [_vm.rules.required],
                          loading: _vm.loadingTransferPhoneAccounts,
                          outlined: "",
                          dense: "",
                          "item-text": "label",
                          "item-value": "accountSid",
                          "hide-details": "auto",
                        },
                        on: { change: _vm.onDestinationAccountChange },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _vm._v(_vm._s(item.accountSid)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.transferPhoneData.destinationAccountSid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.transferPhoneData,
                              "destinationAccountSid",
                              $$v
                            )
                          },
                          expression: "transferPhoneData.destinationAccountSid",
                        },
                      }),
                      _c("v-autocomplete", {
                        staticClass: "mb-2",
                        attrs: {
                          items: _vm.transferPhoneAddressOptions,
                          label: _vm.$t("transfer-phone-destination-address"),
                          loading: _vm.loadingTransferPhoneAddresses,
                          disabled:
                            !_vm.transferPhoneData.destinationAccountSid,
                          outlined: "",
                          dense: "",
                          "item-text": "label",
                          "item-value": "sid",
                          "hide-details": "auto",
                          clearable: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _vm._v(_vm._s(item.sid)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.transferPhoneData.addressSid,
                          callback: function ($$v) {
                            _vm.$set(_vm.transferPhoneData, "addressSid", $$v)
                          },
                          expression: "transferPhoneData.addressSid",
                        },
                      }),
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.transferPhoneNumberOptions,
                          label: _vm.$t("transfer-phone-source-phone-number"),
                          rules: [_vm.rules.required],
                          loading: _vm.loadingTransferPhoneNumbers,
                          disabled: !_vm.transferPhoneData.sourceAccountSid,
                          outlined: "",
                          dense: "",
                          "item-text": "label",
                          "item-value": "sid",
                          "hide-details": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      _vm._v(_vm._s(item.sid)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.transferPhoneData.phoneNumberSid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.transferPhoneData,
                              "phoneNumberSid",
                              $$v
                            )
                          },
                          expression: "transferPhoneData.phoneNumberSid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass: "mt-3 mb-0 transfer-phone-alert",
                      attrs: {
                        type: "info",
                        dense: "",
                        outlined: "",
                        icon: "mdi-clock-outline",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("transfer-phone-emergency-address-warning")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error" },
                      on: { click: _vm.closeTransferPhoneDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        disabled:
                          !_vm.transferPhoneFormValid ||
                          _vm.transferPhoneData.sourceAccountSid ===
                            _vm.transferPhoneData.destinationAccountSid,
                        loading: _vm.loading.transferPhone,
                      },
                      on: { click: _vm.confirmTransferPhone },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }